import { FormattedMessage, useIntl } from 'react-intl';
import { cx } from '@emotion/css';
import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';

import { useStyles } from './choose-service.styles';
import { ChooseServiceProps, ServiceButton } from './choose-service.models';
import { Page } from '../../page/page';
import fit from '../../../../../assets/images/ecp/fit.svg';
import buy from '../../../../../assets/images/ecp/buy.svg';
import cataract from '../../../../../assets/images/ecp/cataract.svg';
import { EcpMap } from '../../ecp-map';
import { InternalLinks } from '../../../../../constants';
import { EcpServices } from '../ecp-locator.models';
import { Preloader } from '../../../../common/preloader';

const buyButton: ServiceButton = {
  key: EcpServices.buy,
  label: <FormattedMessage id="ecp.services.buy" />,
  icon: buy,
  url: `${InternalLinks.ecpLocator}?ecpService=${EcpServices.buy}`,
  testId: 'ecp-buy-service-button', // Don't remove, used by YA analitics
};

const fitButton: ServiceButton = {
  key: EcpServices.fit,
  label: <FormattedMessage id="ecp.services.fit" />,
  icon: fit,
  url: `${InternalLinks.ecpLocator}?ecpService=${EcpServices.fit}`,
  testId: 'ecp-fit-service-button', // Don't remove, used by YA analitics
};

const cataractButton: ServiceButton = {
  key: EcpServices.cataract,
  label: <FormattedMessage id="ecp.services.cataract" />,
  icon: cataract,
  url: `${InternalLinks.ecpLocator}?ecpService=${EcpServices.cataract}`,
  testId: 'ecp-cataract-service-button', // Don't remove, used by YA analitics
  isNew: true,
};

// const cvButton: ServiceButton = {
//   key: EcpServices.cv,
//   label: <FormattedMessage id="ecp.services.controlVisit" />,
//   url: `${InternalLinks.ecpLocator}?ecpService=${EcpServices.cv}`,
//   icon: fit,
// };

// const aecButton: ServiceButton = {
//   key: 'aec',
//   label: <FormattedMessage id="ecp.services.annualEyeCheck" />,
//   icon: fit,
//   url: `${InternalLinks.ecpLocator}?ecpService=${EcpServices.aec}`,
// };

export const ChooseService = ({ isCv, isAec, isFitted, isLoading }: ChooseServiceProps): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();
  const navigate = useNavigate();

  const navigateToService = (url: string, action?: () => void): void => {
    if (action) {
      action();
    }

    navigate(url);
  };

  const buttons = useMemo(() => {
    switch (true) {
      case isCv:
        return [buyButton, fitButton, cataractButton];
        // return [buyButton, cvButton, fitButton, cataractButton]; // Out of scope
      case isAec:
        return [buyButton, fitButton, cataractButton];
        // return [buyButton, aecButton, fitButton, cataractButton]; // Out of scope
      case isFitted:
        return [buyButton, fitButton, cataractButton];
      default:
        return [fitButton, buyButton, cataractButton];
    }
  }, [isCv, isAec]);

  return (
    <>
      {isLoading && <Preloader />}
      {!isLoading && (
        <Page title={intl.formatMessage({ id: 'ecp.services.title' })}>
          <div className={classes.root}>
            <div data-testid="ecp-services" className={classes.services}>
              <h1
                className={classes.title}
                data-testid="ecp-services-title"
              >
                <FormattedMessage id="ecp.services.title" />
              </h1>
              <div className={classes.buttonsContainer}>
                {buttons.map(({ key, label, icon, url, isNew, testId }) => (
                  <button
                    key={key}
                    className={classes.button}
                    data-testid={testId}
                    onClick={(): void => navigateToService(url)}
                  >
                    <img src={icon} alt="" className={classes.icon} />
                    {label}
                    {isNew && <span className={classes.label}><FormattedMessage id="ecp.services.new" /></span>}
                    <span className={classes.arrow} />
                  </button>
                ))}
              </div>
            </div>
            <div data-testid="ecp-map" className={cx(classes.map)}>
              <EcpMap ecpStores={[]} isMapHidden={false} storeDetail={null} isControlsHidden />
            </div>
          </div>
        </Page>
      )}
    </>
  );
};
